export default "__VITE_ASSET__9Uh0$LO8__"